export const sliceDefinitions = {
    "homepage-banner": {
        label: "Bannière Accueil",
        fields: [
            { key: "src", label: "Image", type: "image" },
            { key: "alt", label: "Texte alternatif", type: "text" },
            { key: "bgMask", label: "Masque de fond", type: "boolean" },
            { key: "absolute", label: "fixer en haut de page", type: "boolean" },
            { key: "title", label: "Titre", type: "text" },
            { key: "subtitle", label: "Sous-titre", type: "text" },
            { key: "subtitle2", label: "Sous-titre 2", type: "text" },
            { key: "name", label: "Nom", type: "text" }
        ]
    },
    "homepage-banner-half": {
        label: "Bannière demi-page",
        fields: [
            { key: "src", label: "Image", type: "image" },
            { key: "alt", label: "Texte alternatif", type: "text" },
            { key: "title", label: "Titre", type: "text" },
            { key: "bgMask", label: "Masque de fond", type: "boolean" },
            { key: "absolute", label: "fixer en haut de page", type: "boolean" },
            { key: "subtitle", label: "Sous-titre", type: "text" },
            { key: "subtitle2", label: "Sous-titre 2", type: "text", optional: true },
            { key: "name", label: "Nom", type: "text", optional: true }
        ]
    },
    "horizontal-image-card": {
        label: "Carte Image Horizontale",
        fields: [
            { key: "src", label: "Image", type: "image" },
            { key: "backgroundGradient", label: "Dégradé de fond", type: "text" },
            { key: "title", label: "Titre", type: "text" },
            { key: "description", label: "Description", type: "textarea" },
            { key: "button", label: "Texte du bouton", type: "text" },
            { key: "buttonColor", label: "Couleur du bouton", type: "text" },
            { key: "buttonHref", label: "Lien du bouton", type: "text" },
            { key: "position", label: "Position de l'image", type: "text" }
        ]
    },
    "horizontal-text-card": {
        label: "Carte Texte Horizontale",
        fields: [
            { key: "version", label: "Version", type: "text" },
            { key: "title", label: "Titre", type: "text" },
            { key: "description", label: "Description", type: "textarea" },
            { key: "button", label: "Texte du bouton", type: "text" },
            { key: "buttonHref", label: "Lien du bouton", type: "text" },
            { key: "position", label: "Position du texte", type: "text" }
        ]
    },
    "text-card": {
        label: "Carte Texte",
        fields: [
            { key: "title", label: "Titre", type: "text" },
            { key: "description", label: "Description", type: "textarea" },
            { key: "button", label: "Texte du bouton", type: "text", optional: true },
            { key: "buttonColor", label: "Couleur du bouton", type: "text", optional: true },
            { key: "buttonHref", label: "Lien du bouton", type: "text", optional: true }
        ]
    },
    "paragraph": {
        label: "Paragraphe",
        fields: [
            { key: "paragraph", label: "Texte", type: "textarea" },
            { key: "size", label: "Taille", type: "text", optional: true },
            { key: "justify", label: "Justification", type: "text", optional: true }
        ]
    },
    "title": {
        label: "Titre",
        fields: [
            { key: "title", label: "Titre", type: "text" }
        ]
    },
    "quote": {
        label: "Citation",
        fields: [
            { key: "text", label: "Texte", type: "textarea" }
        ]
    },
    "divider": { label: "Séparateur", fields: [] },
    "space": { label: "Espace", fields: [] },
    "square-card-list": {
        label: "Liste de Cartes Carrées",
        arrayField: {
            key: "data",
            label: "Cartes",
            fields: [
                { key: "image", label: "Image", type: "image" },
                { key: "title", label: "Titre", type: "text" },
                { key: "description", label: "Description", type: "textarea" },
                { key: "link", label: "Lien", type: "text" },
            ]
        },
        fields: []
    },
    "cards-carousel": {
        label: "Carrousel de Cartes",
        fields: [
            { key: "title", label: "Titre", type: "text" },
            { key: "cardData", label: "Source des cartes", type: "text" }
        ]
    },
    "destination-carousel-swiper": {
        label: "Carrousel Destination",
        fields: [
            { key: "title", label: "Titre", type: "text" },
            { key: "subtitle", label: "Sous-titre", type: "text" },
        ],
        arrayField: {
            key: "data",
            label: "Peintures",
            fields: [
                { key: "name", label: "Nom", type: "text" },
                { key: "description", label: "Description", type: "textarea" },
                { key: "imageUrl", label: "Image", type: "image" },
                { key: "link", label: "Lien", type: "text" }
            ]
        }
    },
    "grid-presentation": {
        label: "Grille de Présentation",
        fields: [
            { key: "contactInfo.icon", label: "Icône Contact", type: "image" },
            { key: "contactInfo.title", label: "Titre Contact", type: "text" },
            { key: "contactInfo.address", label: "Adresse", type: "text" },
            { key: "contactInfo.phone", label: "Téléphone", type: "text" },
            { key: "contactInfo.email", label: "Email", type: "text" },
            { key: "contactInfo.mapImage", label: "Image Carte", type: "image" },
            { key: "contactInfo.href", label: "Lien Contact", type: "text" },
            { key: "contactInfo.button", label: "Bouton Contact", type: "text" },
        ],
        arrayField: {
            key: 'services',
            label: 'Services',
            fields: [
                { key: 'icon', label: 'Icône', type: 'image' },
                { key: 'title', label: 'Titre', type: 'text' },
                { key: 'description', label: 'Description', type: 'textarea' },
                { key: 'link', label: 'Lien', type: 'text' },
            ]
        },

    },
    "contact-split-section": {
        label: 'Section Contact avec Image',
        fields: [
            { key: 'backgroundImage', label: 'Image de fond', type: 'image' },
            { key: 'title', label: 'Titre', type: 'text' },
            { key: 'description', label: 'Description', type: 'textarea' },
            { key: 'bottomBackgroundImage', label: 'Image de fond basse', type: 'image' }
        ],
        nestedFields: {
            key: 'contactInfo',
            label: 'Infos Contact',
            fields: [
                { key: 'location', label: 'Adresse', type: 'text' },
                { key: 'phone', label: 'Téléphone', type: 'text' },
                { key: 'email', label: 'Email', type: 'text' },
                { key: 'hours', label: 'Horaires', type: 'text' }
            ]
        }
    },
    "sport-hero-banner": {
        label: 'Bannière Héros Sport',
        fields: [
            { key: 'title', label: 'Titre', type: 'text' },
            { key: 'subtitle', label: 'Sous-titre', type: 'text' },
            { key: 'inlineSubtitle', label: 'Sous-titre en ligne', type: 'text' },
            { key: 'maskFissures', label: 'Image de fissures', type: 'image' },
            { key: 'bgImage', label: 'Image de fond', type: 'image' },
            { key: 'bgVideo', label: 'Vidéo de fond', type: 'text' },
            { key: 'isImage', label: 'Image ou vidéo ?', type: 'boolean' }
        ]
    },
    "sport-logo-carousel": {
        label: 'Carrousel de logos',
        arrayField: {
            key: 'logos',
            label: 'Logos',
            type: 'image'
        },
        fields: []
    },
    "sport-statistiques": {
        label: 'Statistiques sport',
        fields: [
            { key: 'title', label: 'Titre', type: 'text' }
        ],
        arrayField: {
            key: 'statsData',
            label: 'Statistiques',
            fields: [
                { key: 'label', label: 'Nom', type: 'text' },
                { key: 'count', label: 'Nombre', type: 'number' },
                { key: 'link', label: 'Lien', type: 'text' },
                { key: 'icon', label: 'Icône', type: 'image' },
                { key: 'hoverText', label: 'Texte au survol', type: 'text' }
            ]
        }
    },
    "sport-statistiques-percent": {
        label: 'Statistiques en pourcentage',
        fields: [
            { key: 'title', label: 'Titre', type: 'text' }
        ],
        arrayField: {
            key: 'statsPercentageData',
            label: 'Statistiques',
            fields: [
                { key: 'label', label: 'Nom', type: 'text' },
                { key: 'count', label: 'Nombre', type: 'number' },
                { key: 'percentage', label: 'Pourcentage', type: 'number' },
                { key: 'link', label: 'Lien', type: 'text' }
            ]
        }
    },
    "sport-flying-text-on-image": {
        label: 'Texte flottant sur image',
        fields: [
            { key: 'title', label: 'Titre', type: 'text' },
            { key: 'description', label: 'Description', type: 'textarea' },
            { key: 'backgroundColor', label: 'Couleur de fond', type: 'color' },
            { key: 'textColor', label: 'Couleur du texte', type: 'color' },
            { key: 'titleColor', label: 'Couleur du titre', type: 'color' },
            { key: 'buttonColor', label: 'Couleur du bouton', type: 'color' },
            { key: 'showButton', label: 'Afficher le bouton', type: 'boolean' },
            { key: 'buttonText', label: 'Texte du bouton', type: 'text' },
            { key: 'imageUrl', label: 'Image', type: 'image' }
        ]
    },
    "sport-text-video": {
        label: 'Bloc texte + vidéo',
        fields: [
            { key: 'title', label: 'Titre', type: 'text' },
            { key: 'description', label: 'Description', type: 'textarea' },
            { key: 'imageUrl', label: 'Image', type: 'image' },
            { key: 'videoUrl', label: 'Vidéo', type: 'text' },
            { key: 'frameUrl', label: 'Cadre décoratif', type: 'image' },
            { key: 'backgroundColor', label: 'Couleur de fond', type: 'color' },
            { key: 'textColor', label: 'Couleur du texte', type: 'color' },
            { key: 'titleColor', label: 'Couleur du titre', type: 'color' },
            { key: 'buttonColor', label: 'Couleur du bouton', type: 'color' },
            { key: 'showButton', label: 'Afficher le bouton', type: 'boolean' },
            { key: 'buttonText', label: 'Texte du bouton', type: 'text' }
        ]
    },
    "sport-card-grid": {
        label: 'Grille de cartes sportifs',
        fields: [
            { key: 'title', label: 'Titre', type: 'text' },
            { key: 'theme', label: 'Thème', type: 'text' }
        ],
        arrayField: {
            key: 'sportifs',
            label: 'Sportifs',
            fields: [
                { key: 'name', label: 'Nom', type: 'text' },
                { key: 'sport', label: 'Sport', type: 'text' },
                { key: 'image', label: 'Image', type: 'image' },
                { key: 'showButton', label: 'Afficher bouton', type: 'boolean' }
            ]
        }
    },
    "sport-picture-phrase": {
        label: 'Image avec phrase',
        fields: [
            { key: 'imageUrl', label: 'Image', type: 'image' },
            { key: 'imageHeight', label: 'Hauteur', type: 'text' },
            { key: 'imageWidth', label: 'Largeur', type: 'text' },
            { key: 'phrase', label: 'Phrase', type: 'text' },
            { key: 'details', label: 'Détails', type: 'textarea' },
            { key: 'buttonText', label: 'Texte bouton', type: 'text' }
        ]
    },
    "sport-two-columns": {
        label: 'Deux colonnes texte',
        fields: [
            { key: 'eyebrow', label: 'Sur-titre', type: 'text' },
            { key: 'title', label: 'Titre', type: 'text' },
            { key: 'leftText', label: 'Texte gauche', type: 'textarea' },
            { key: 'rightText', label: 'Texte droite', type: 'textarea' },
            { key: 'buttonText', label: 'Texte bouton', type: 'text' },
            { key: 'theme', label: 'Thème', type: 'text' },
            { key: 'showButton', label: 'Afficher bouton', type: 'boolean' }
        ]
    },
    "sport-three-pictures-title": {
        label: 'Trois images + titre',
        fields: [
            { key: 'mainImage', label: 'Image principale', type: 'image' },
            { key: 'topTitle', label: 'Titre haut', type: 'text' },
            { key: 'bottomTitle', label: 'Titre bas', type: 'text' },
            { key: 'sideImageOne', label: 'Image latérale 1', type: 'image' },
            { key: 'sideImageTwo', label: 'Image latérale 2', type: 'image' },
            { key: 'imageOnLeft', label: 'Image à gauche', type: 'boolean' },
            { key: 'titleAbove', label: 'Titre au-dessus', type: 'boolean' },
            { key: 'theme', label: 'Thème', type: 'text' }
        ]
    },
    "sport-scroll-images": {
        label: 'Bloc d’images défilantes',
        fields: [
            { key: 'imageGap', label: 'Espacement', type: 'text' },
            { key: 'cardBackgroundColor', label: 'Couleur fond carte', type: 'color' },
            { key: 'buttonColor', label: 'Couleur bouton', type: 'color' },
            { key: 'hoverEffect', label: 'Effet au survol', type: 'boolean' }
        ],
        arrayField: {
            key: 'items',
            label: 'Éléments',
            fields: [
                { key: 'imageUrl', label: 'Image', type: 'image' },
                { key: 'eyebrow', label: 'Sur-titre', type: 'text' },
                { key: 'title', label: 'Titre', type: 'text' },
                { key: 'description', label: 'Description', type: 'textarea' },
                { key: 'showButton', label: 'Afficher bouton', type: 'boolean' }
            ]
        }
    },
    "four-section-split": {
        label: 'Grille 4 sections',
        nestedFields: [
            {
                key: 'topLeft',
                label: 'Haut gauche',
                fields: [{ key: 'imageUrl', label: 'Image', type: 'image' }]
            },
            {
                key: 'topRight',
                label: 'Haut droite',
                fields: [
                    { key: 'title', label: 'Titre', type: 'text' },
                    { key: 'subtitle', label: 'Sous-titre', type: 'text' },
                    { key: 'description', label: 'Description', type: 'textarea' },
                    { key: 'imageUrl', label: 'Image', type: 'image' }
                ]
            },
            {
                key: 'bottomLeft',
                label: 'Bas gauche',
                fields: [
                    { key: 'title', label: 'Titre', type: 'text' },
                    { key: 'subtitle', label: 'Sous-titre', type: 'text' },
                    { key: 'description', label: 'Description', type: 'textarea' },
                    { key: 'imageUrl', label: 'Image', type: 'image' }
                ]
            },
            {
                key: 'bottomRight',
                label: 'Bas droite',
                fields: [{ key: 'imageUrl', label: 'Image', type: 'image' }]
            }
        ]
    },
    "travel-hero-banner": {
        label: 'travel hero banner',
        fields: [
            { key: 'bgImage', label: 'bgImage', type: 'text' },
            { key: 'title', label: 'title', type: 'text' },
            { key: 'subtitle', label: 'subtitle', type: 'text' },
            { key: 'cta', label: 'cta', type: 'text' },
            { key: 'ctaLink', label: 'ctaLink', type: 'text' },
            { key: 'mask', label: 'mask', type: 'boolean' }
        ]
    },
    "div-one": {
        label: 'div one',
        fields: [
            { key: 'imageUrl', label: 'imageUrl', type: 'text' },
            { key: 'subheading', label: 'subheading', type: 'text' },
            { key: 'title', label: 'title', type: 'text' },
            { key: 'text', label: 'text', type: 'text' },
            { key: 'buttonLabel', label: 'buttonLabel', type: 'text' },
            { key: 'buttonUrl', label: 'buttonUrl', type: 'text' }
        ]
    },
    "travel-destination-carousel": {
        label: 'travel destination carousel',
        fields: [
            { key: 'title', label: 'title', type: 'text' },
            { key: 'subtitle', label: 'subtitle', type: 'text' }
        ],
        arrayField: {
            key: 'destinations',
            label: 'Destinations',
            fields: [
                { key: 'name', label: 'name', type: 'text' },
                { key: 'description', label: 'description', type: 'text' },
                { key: 'imageUrl', label: 'imageUrl', type: 'text' },
                { key: 'link', label: 'link', type: 'text' }
            ]
        }
    },
    "blog-div-comp": {
        label: 'blog div comp',
        fields: [
            { key: 'title', label: 'title', type: 'text' },
            { key: 'subtitle', label: 'subtitle', type: 'text' },
            { key: 'description', label: 'description', type: 'text' },
            { key: 'link', label: 'link', type: 'text' },
            { key: 'largeImage', label: 'largeImage', type: 'text' },
            { key: 'smallImage', label: 'smallImage', type: 'text' },
            { key: 'cta', label: 'cta', type: 'text' }
        ]
    },
    "travel-full-with-gradient": {
        label: 'travel full with gradient',
        fields: [
            { key: 'src', label: 'src', type: 'text' },
            { key: 'alt', label: 'alt', type: 'text' },
            { key: 'fadeColor', label: 'fadeColor', type: 'text' },
            { key: 'blurAmount', label: 'blurAmount', type: 'text' },
            { key: 'overlayHeight', label: 'overlayHeight', type: 'text' },
            { key: 'height', label: 'height', type: 'text' }
        ]
    },
    "travel-quote": {
        label: 'travel quote',
        fields: [
            { key: 'text', label: 'text', type: 'text' },
            { key: 'author', label: 'author', type: 'text' },
            { key: 'fontSize', label: 'fontSize', type: 'text' },
            { key: 'animationDirection', label: 'animationDirection', type: 'text' },
            { key: 'animationDelay', label: 'animationDelay', type: 'text' },
            { key: 'theme', label: 'theme', type: 'text' },
            { key: 'variant', label: 'variant', type: 'text' },
            { key: 'backgroundImage', label: 'backgroundImage', type: 'text' }
        ]
    },
    "travel-feature-block": {
        label: 'travel feature block',
        fields: [
            { key: 'title', label: 'title', type: 'text' },
            { key: 'text', label: 'text', type: 'text' },
            { key: 'imageUrl', label: 'imageUrl', type: 'text' },
            { key: 'imageAlt', label: 'imageAlt', type: 'text' },
            { key: 'imageCaption', label: 'imageCaption', type: 'text' },
            { key: 'bgColor', label: 'bgColor', type: 'text' },
            { key: 'backgroundWidth', label: 'backgroundWidth', type: 'text' },
            { key: 'backgroundHeight', label: 'backgroundHeight', type: 'text' },
            { key: 'roundedBackground', label: 'roundedBackground', type: 'boolean' },
            { key: 'imageWidth', label: 'imageWidth', type: 'text' },
            { key: 'imageHeight', label: 'imageHeight', type: 'text' },
            { key: 'titleFont', label: 'titleFont', type: 'text' },
            { key: 'textFont', label: 'textFont', type: 'text' },
            { key: 'captionFont', label: 'captionFont', type: 'text' },
            { key: 'captionBackground', label: 'captionBackground', type: 'boolean' },
            { key: 'showButton', label: 'showButton', type: 'boolean' },
            { key: 'buttonLabel', label: 'buttonLabel', type: 'text' },
            { key: 'buttonUrl', label: 'buttonUrl', type: 'text' },
            { key: 'roundedImage', label: 'roundedImage', type: 'boolean' },
            { key: 'animation', label: 'animation', type: 'text' },
            { key: 'animationDelay', label: 'animationDelay', type: 'text' },
            { key: 'imagePosition', label: 'imagePosition', type: 'text' },
            { key: 'darkMode', label: 'darkMode', type: 'boolean' }
        ]
    }
};